import React, { useEffect, useState, memo, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, MTable, Text } from "@cisco/spaces-dash-lib-styleguide";
import { permissionFormatter } from "./formatter";
import { getAdminList } from "../../service/user-service";
import useLoader from "../../hooks/useLoader";
import { I18nContext } from "../../contexts/i18nContext";

function UserTable({ searchBy }) {
  const i18n = useContext(I18nContext);
  const { setLoading } = useLoader();
  const [adminData, setAdminData] = useState([]);

  const navigate = useNavigate();

  const searchByKeyWord = () => {
    const results = adminData.filter((item) => {
      return (
        item?.user?.name?.toLowerCase().includes(searchBy?.toLowerCase()) ||
        item?.user?.email?.toLowerCase().includes(searchBy?.toLowerCase()) ||
        item?.status?.toLowerCase().includes(searchBy?.toLowerCase()) ||
        item?.role?.toLowerCase().includes(searchBy?.toLowerCase()) ||
        item?.permissionsRW?.some((permission) => permission.toLowerCase().includes(searchBy?.toLowerCase())) ||
        item?.permissionsR?.some((permission) => permission.toLowerCase().includes(searchBy?.toLowerCase())) ||
        item?.locations?.some((location) => location.toLowerCase().includes(searchBy?.toLowerCase()))
      );
    });

    return results;
  };

  const getFormattedData = (data) => {
    const formattedData = data.map((ele) => {
      const { firstName, lastName, email, status, role } = ele;
      return {
        user: { name: `${firstName} ${lastName}`, email },
        status,
        role: role.roleName,
        roleId: role.roleId,
        permissionsRW: ele.role.details.filter((ele1) => ele1.appRole == "RW").map((ele2) => ele2.appDisplayName),
        permissionsR: ele.role.details.filter((ele3) => ele3.appRole == "RO").map((ele4) => ele4.appDisplayName),
        locations: ele.locations.map((ele5) => ele5.name)
      };
    });

    return searchBy ? searchByKeyWord(formattedData) : formattedData;
  };

  const filteredData = searchByKeyWord();

  const fetchData = () => {
    setAdminData([]);
    setLoading(true);
    getAdminList()
      .then((res) => {
        setAdminData(getFormattedData(res?.data || []) || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
    i18n.loadNamespaces("spaces-dash-app-admin");
  }, []);
  //   <STable
  //     enableRowSelection={false}
  //     enableRowActions={false}
  //     enablePagination
  //     columns={[
  //       {
  //         accessorKey: "user",
  //         header: "User",
  //         meta: {
  //           align: "left"
  //         },
  //         cell: (data) => (
  //           <>
  //             <span
  //               className="user-link"
  //               role="button"
  //               onKeyDown={() => {
  //                 navigate(`/team/edit?email=${data.renderValue().email}`);
  //               }}
  //               tabIndex={-1}
  //               onClick={() => {
  //                 navigate(`/team/edit?email=${data.renderValue().email}`);
  //               }}
  //             >
  //               <Text color="#0d5cbd" size="p2" weight="bold">
  //                 {data.getValue().name !== undefined ? data.renderValue().name : "—"}
  //               </Text>
  //             </span>
  //             <Text color="#858585 " size="p3">
  //               {data.getValue().email !== undefined ? data.renderValue().email : "—"}
  //             </Text>

  //             {data?.row?.original?.status?.toLowerCase() === "pending" && (
  //               <Text style={{ color: "#58585b" }}>
  //                 Invited - Not yet responded.
  //                 <Text
  //                   style={{
  //                     fontSize: "12px",
  //                     fontWeight: 600,
  //                     color: "#0d5cbd",
  //                     textDecoration: "underline",
  //                     cursor: "pointer"
  //                   }}
  //                   onClick={() =>
  //                     resendInvite({
  //                       email: data.renderValue().email,
  //                       roleId: data?.row?.original?.roleId
  //                     })
  //                   }
  //                 >
  //                   RESEND?
  //                 </Text>
  //               </Text>
  //             )}
  //           </>
  //         )
  //       },
  //       {
  //         accessorKey: "role",
  //         header: "Role",
  //         meta: {
  //           align: "left"
  //         }
  //       },
  //       {
  //         accessorKey: "permissionsRW",
  //         header: "Permissions: Read & Write",
  //         meta: {
  //           align: "left"
  //         },
  //         cell: (data) => permissionFormatter(data, "Permissions: Read & Write")
  //       },
  //       {
  //         accessorKey: "permissionsR",
  //         header: "Permissions: Read Only",
  //         meta: {
  //           align: "left"
  //         },
  //         cell: (data) => permissionFormatter(data, "Permissions: Read Only")
  //       },
  //       {
  //         accessorKey: "locations",
  //         header: "Locations",
  //         meta: {
  //           align: "left"
  //         }
  //       }
  //     ]}
  //     data={filteredData}
  //   />
  // ) : (
  //   ""
  // );

  return (
    <Flex style={{ padding: "24px" }}>
      <MTable.Pagination currentPage={1} defaultRecordsOption="10" showNavigation="all" showOptions showTotal>
        <MTable
          columns={[
            {
              accessorKey: "user",
              header: i18n.t("admin-management.adminsTableHeaders.user", { ns: "spaces-dash-app-admin" }),
              meta: {
                align: "left"
              },
              cell: (data) => (
                <>
                  <span
                    className="user-link"
                    role="button"
                    style={{ cursor: "pointer" }}
                    onKeyDown={() => {
                      navigate(`/team/edit?email=${data.renderValue().email}`);
                    }}
                    tabIndex={-1}
                    onClick={() => {
                      navigate(`/team/edit?email=${data.renderValue().email}`);
                    }}
                  >
                    <Text color="#0d5cbd" size="p2" weight="bold">
                      {data.getValue().name !== undefined ? data.renderValue().name : "—"}
                    </Text>
                  </span>
                  <Text color="#858585 " size="p3">
                    {data.getValue().email !== undefined ? data.renderValue().email : "—"}
                  </Text>
                </>
              )
            },
            {
              accessorKey: "role",
              header: i18n.t("admin-management.adminsTableHeaders.role", { ns: "spaces-dash-app-admin" }),
              meta: {
                align: "left"
              }
            },
            {
              accessorKey: "permissionsRW",
              header: i18n.t("admin-management.adminsTableHeaders.Permissions-Read-Write", { ns: "spaces-dash-app-admin" }),
              meta: {
                align: "left"
              },
              cell: (data) => permissionFormatter(data, "Permissions: Read & Write")
            },
            {
              accessorKey: "permissionsR",
              header: i18n.t("admin-management.adminsTableHeaders.Permissions-Read", { ns: "spaces-dash-app-admin" }),
              meta: {
                align: "left"
              },
              cell: (data) => permissionFormatter(data, "Permissions: Read Only")
            },
            {
              accessorKey: "locations",
              header: i18n.t("admin-management.adminsTableHeaders.locations", { ns: "spaces-dash-app-admin" }),
              meta: {
                align: "left"
              }
            }
          ]}
          data={filteredData}
        />
      </MTable.Pagination>
    </Flex>
  );
}

export default memo(UserTable);
